import { render, staticRenderFns } from "./AddToCartComponent.vue?vue&type=template&id=563e0460"
import script from "./AddToCartComponent.vue?vue&type=script&lang=js"
export * from "./AddToCartComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports